import { useTranslation } from 'react-i18next';
import { Tabs } from '@/components/ui/tabs';
import { useRoutedTabs } from '@/Pages/routedTabs';
import { STOREFRONT_TABS } from '@/Pages/tabRoutes';
import BrandingTab from './BrandingTab';
import DomainsTab from './DomainsTab';
import BranchesTab from './BranchesTab';
import AbandonedCartsTab from './AbandonedCartsTab';

/**
 * ADR-0016 §8 — the branded online-ordering storefront had one file mention
 * and no admin surface at all before this pass. Branding, the custom domain
 * and its DNS verification state, which branches publish and on what terms,
 * SEO metadata and abandoned-cart telemetry all live here, on
 * `storefront.*` — a permission resource only Tenant Owner/Admin hold by
 * default (see `storefrontLib.ts`).
 */
export default function Storefront() {
  const { t } = useTranslation();
  const routed = useRoutedTabs('/storefront', STOREFRONT_TABS);
  if (!routed.open) return routed.redirect;
  const { tabs, current, select } = routed;

  return (
    <div className="space-y-5">
      <div>
        <h1 className="text-2xl font-semibold">{t('storefront.title')}</h1>
        <p className="text-sm text-ink-muted">{t('storefront.subtitle')}</p>
      </div>

      <Tabs
        tabs={tabs.map((entry) => ({ key: entry.id, label: t(entry.labelKey) }))}
        value={current}
        onChange={select}
        label={t('storefront.title')}
        idPrefix="storefront"
        className="scrollbar-thin gap-x-5 overflow-x-auto"
      />

      {current === 'branding' && <BrandingTab />}
      {current === 'domains' && <DomainsTab />}
      {current === 'branches' && <BranchesTab />}
      {current === 'carts' && <AbandonedCartsTab />}
    </div>
  );
}
